import {
  SET_MODEL_WORKFLOW
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_MODEL_WORKFLOW:
      return action.payload;

    default:
      return state;
  }
}